import React from 'react'
import { bindActionCreators } from 'redux'
import { connect } from 'react-redux'

import { fetchArqueos } from '../actions/arqueos'
import { fetchCustomers } from '../actions/customers'
import ErrorMessage from '../components/ErrorMessage'
import LoadingProgress from '../components/LoadingProgress'
import { push } from 'react-router-redux'
import '../styles/CommissionsView.css'

class ComissionsView extends React.Component {
  constructor(props) {
    super(props)

    this.state = {
      VWPACKComission: 0.05,
      VWLAYComission: 0.03,
      VWGOComission: 0.15,
      filterCustomer: '',
      filterYear: new Date().getFullYear().toString(),
      filterLoading: false,
    }

    this.handleFilterApply = this.handleFilterApply.bind(this);
  }

  goTo(client, year, e) {

    this.props.push('/comissions/details', { client: client, year: year })
  }

  componentDidMount() {
    const today = new Date();
    const currentYear = today.getFullYear();

    const yearStart = new Date(currentYear, 0, 1);
    const formattedStartDate =
      `${yearStart.getFullYear()}-${(yearStart.getMonth() + 1).toString().padStart(2, '0')}-${yearStart.getDate().toString().padStart(2, '0')}`;
    const yearEnd = new Date(currentYear + 1, 0, 0);
    const formattedEndDate =
      `${yearEnd.getFullYear()}-${(yearEnd.getMonth() + 1).toString().padStart(2, '0')}-${yearEnd.getDate().toString().padStart(2, '0')}`;

    this.props.fetchArqueos('', '', formattedStartDate, formattedEndDate, '');
    this.props.fetchCustomers();
  }

  handleFilterApply() {
    const { filterCustomer, filterYear } = this.state;
    const year = parseInt(filterYear, 10);
    const yearStart = new Date(year, 0, 1);
    const formattedStartDate =
      `${yearStart.getFullYear()}-${(yearStart.getMonth() + 1).toString().padStart(2, '0')}-${yearStart.getDate().toString().padStart(2, '0')}`;
    const yearEnd = new Date(year + 1, 0, 0);
    const formattedEndDate =
      `${yearEnd.getFullYear()}-${(yearEnd.getMonth() + 1).toString().padStart(2, '0')}-${yearEnd.getDate().toString().padStart(2, '0')}`;

    this.setState({ filterLoading: true });
    this.props.fetchArqueos('', filterCustomer, formattedStartDate, formattedEndDate, '')
      .then(() => this.setState({ filterLoading: false }))
      .catch(() => this.setState({ filterLoading: false }));
  }

  calculatePriceWithoutTaxAndComission(priceWithTax, taxRate, comissionRate) {
    // Convert tax rate from percentage to decimal
    const taxMultiplier = 1 + taxRate / 100;

    let comissionMultiplier = 1;

    comissionRate != 0 ? comissionMultiplier = comissionRate / 100 : comissionMultiplier = 1

    // Calculate price without tax and round to two decimal places
    const priceWithoutTaxAndComission = ((priceWithTax / taxMultiplier) * comissionMultiplier).toFixed(2);

    // Convert the string back to a number
    return parseFloat(priceWithoutTaxAndComission);
  }

  calculateUnitsCustomerTotals(customer) {
    const { arqueos } = this.props;

    // Initialize an object to store monthly totals
    const monthlyTotals = {
      productTotal: 0,
      VWPACKTotal: 0,
      VWGOTotal: 0,
      VWLAYTotal: 0,
    };

    let year = 0;
    let customerID = "";

    // Iterate through arqueos to find the ones belonging to the current customer
    arqueos.forEach(arqueo => {
      if (arqueo.Customer && arqueo.Customer.Fullname === customer && arqueo.Customer._id !== "627e3b97db8dc91eb9cc3ac2") {

        // Extract month from the timestamp
        const month = new Date(arqueo.TimeStamp).getUTCMonth();

        monthlyTotals.productTotal += (this.calculatePriceWithoutTaxAndComission(arqueo.ItemsPrices.VWPACK, arqueo.Tax, arqueo.ItemsComissions.VWPACK) || 0) + (this.calculatePriceWithoutTaxAndComission(arqueo.ItemsPrices.VWGO, arqueo.Tax, arqueo.ItemsComissions.VWGO) || 0) + (this.calculatePriceWithoutTaxAndComission(arqueo.ItemsPrices.VWLAY, arqueo.Tax, arqueo.ItemsComissions.VWLAY) || 0);
        monthlyTotals.VWPACKTotal += arqueo.Items.VWPACK || 0;
        monthlyTotals.VWGOTotal += arqueo.Items.VWGO || 0;
        monthlyTotals.VWLAYTotal += arqueo.Items.VWLAY || 0;

        year == 0 ? year = new Date(arqueo.TimeStamp).getFullYear() : ''
        customerID = arqueo.Customer._id

      }
    });

    return {
      customerName: customer,
      monthlyTotals,
      year: year,
      customerID: customerID
    };
  }

  createUnitsClientsArray() {
    const { arqueos } = this.props;

    if (!arqueos) return [];

    const customers = Array.from(new Set(arqueos.map(arqueo => arqueo.Customer && arqueo.Customer.Fullname)));
    const clientsArray = [];

    customers.forEach(customer => {
      if (customer && customer !== "VACWAY WATERPROOF SL") {
        const customerTotals = this.calculateUnitsCustomerTotals(customer);
        clientsArray.push(customerTotals);
      }
    });

    clientsArray.sort((a, b) => b.monthlyTotals.productTotal - a.monthlyTotals.productTotal);

    return clientsArray;
  }

  render() {
    const { arqueos, loading, error, customers, role } = this.props;
    const { filterCustomer, filterYear, filterLoading } = this.state;

    if (error) {
      return <ErrorMessage message={error.message} />;
    }

    const clientsArray = (!arqueos || loading) ? [] : this.createUnitsClientsArray();

    const totalRow = {
      monthlyTotals: {
        productTotal: clientsArray.reduce((sum, c) => sum + c.monthlyTotals.productTotal, 0),
        VWPACKTotal: clientsArray.reduce((sum, c) => sum + c.monthlyTotals.VWPACKTotal, 0),
        VWLAYTotal: clientsArray.reduce((sum, c) => sum + c.monthlyTotals.VWLAYTotal, 0),
        VWGOTotal: clientsArray.reduce((sum, c) => sum + c.monthlyTotals.VWGOTotal, 0),
      },
    };

    const totalComissions =
      (totalRow.monthlyTotals.VWPACKTotal * this.state.VWPACKComission) +
      (totalRow.monthlyTotals.VWLAYTotal * this.state.VWLAYComission) +
      (totalRow.monthlyTotals.VWGOTotal * this.state.VWGOComission);

    return (
      <div className="com-view">
        {/* Header */}
        <div className="com-header">
          <div className="header-content">
            <div className="header-text">
              <h1>
                <i className="fas fa-hand-holding-usd mr-1"></i>
                <span className="text-vw-dark mr-2">Comisiones de </span>
                <span className="text-vw-light">Venta</span>
              </h1>
            </div>
            <div className="com-header-filter-inline">
              {role === 'ADMIN' && (
                <div className="com-filter-field">
                  <label>Cliente</label>
                  <select
                    className="form-control"
                    value={filterCustomer}
                    onChange={e => this.setState({ filterCustomer: e.target.value })}
                  >
                    <option value="">Todos</option>
                    {customers && customers
                      .sort((a, b) => a.Fullname.localeCompare(b.Fullname))
                      .map(c => <option key={c._id} value={c._id}>{c.Fullname}</option>)
                    }
                  </select>
                </div>
              )}
              <div className="com-filter-field">
                <label>Año</label>
                <select
                  className="form-control"
                  value={filterYear}
                  onChange={e => this.setState({ filterYear: e.target.value })}
                >
                  {Array.from({ length: 13 }, (_, i) => 2018 + i).map(y => (
                    <option key={y} value={y}>{y}</option>
                  ))}
                </select>
              </div>
              <button
                className="com-btn primary"
                onClick={this.handleFilterApply}
                disabled={filterLoading}
              >
                {filterLoading
                  ? <><i className="fas fa-spinner fa-spin"></i> Cargando...</>
                  : <><i className="fas fa-sync"></i> Aplicar</>
                }
              </button>
            </div>
          </div>
        </div>

        {/* KPI Cards */}
        {(!arqueos || loading)
          ? <LoadingProgress />
          : (
            <div className="com-kpi-row">
              <div className="com-kpi-card generated">
                <div className="kpi-icon"><i className="fas fa-coins"></i></div>
                <div className="kpi-content">
                  <div className="kpi-value">{totalRow.monthlyTotals.productTotal.toFixed(2)} €</div>
                  <div className="kpi-label">Total Generado</div>
                </div>
              </div>
              <div className="com-kpi-card commissions">
                <div className="kpi-icon"><i className="fas fa-percentage"></i></div>
                <div className="kpi-content">
                  <div className="kpi-value">{totalComissions.toFixed(2)} €</div>
                  <div className="kpi-label">Total Comisiones</div>
                </div>
              </div>
              <div className="com-kpi-card clients">
                <div className="kpi-icon"><i className="fas fa-users"></i></div>
                <div className="kpi-content">
                  <div className="kpi-value">{clientsArray.length}</div>
                  <div className="kpi-label">Clientes</div>
                </div>
              </div>
            </div>
          )
        }

        {/* Client List */}
        {(!arqueos || loading) ? null : (
          <div className="com-list-wrapper">
            <div className="com-list-header">
              <div className="com-col col-customer">Cliente</div>
              <div className="com-col col-total">Total Generado</div>
              <div className="com-col col-comission">Total Comisiones</div>
              <div className="com-col col-product">VWPACK</div>
              <div className="com-col col-product">VWLAY</div>
              <div className="com-col col-product">VWGO</div>
            </div>

            {/* Totals row */}
            <div className="com-client-card totals-row">
              <div className="com-client-row">
                <div className="com-col col-customer">Todos los clientes</div>
                <div className="com-col col-total">{totalRow.monthlyTotals.productTotal.toFixed(2)} €</div>
                <div className="com-col col-comission">{totalComissions.toFixed(2)} €</div>
                <div className="com-col col-product">
                  <div className="com-amount">{(totalRow.monthlyTotals.VWPACKTotal * this.state.VWPACKComission).toFixed(2)} €</div>
                  <div className="com-units">{totalRow.monthlyTotals.VWPACKTotal} uds</div>
                </div>
                <div className="com-col col-product">
                  <div className="com-amount">{(totalRow.monthlyTotals.VWLAYTotal * this.state.VWLAYComission).toFixed(2)} €</div>
                  <div className="com-units">{totalRow.monthlyTotals.VWLAYTotal} uds</div>
                </div>
                <div className="com-col col-product">
                  <div className="com-amount">{(totalRow.monthlyTotals.VWGOTotal * this.state.VWGOComission).toFixed(2)} €</div>
                  <div className="com-units">{totalRow.monthlyTotals.VWGOTotal} uds</div>
                </div>
              </div>
            </div>

            {/* Client rows */}
            {clientsArray.map((client, index) => {
              const packComission = client.monthlyTotals.VWPACKTotal * this.state.VWPACKComission;
              const layComission = client.monthlyTotals.VWLAYTotal * this.state.VWLAYComission;
              const goComission = client.monthlyTotals.VWGOTotal * this.state.VWGOComission;
              const totalClientComissions = packComission + layComission + goComission;

              return (
                <div
                  key={index}
                  className="com-client-card"
                  onClick={e => this.goTo(client.customerID, client.year, e)}
                >
                  <div className="com-client-row">
                    <div className="com-col col-customer">{client.customerName}</div>
                    <div className="com-col col-total">{client.monthlyTotals.productTotal.toFixed(2)} €</div>
                    <div className="com-col col-comission">{totalClientComissions.toFixed(2)} €</div>
                    <div className="com-col col-product">
                      <div className="com-amount">{packComission.toFixed(2)} €</div>
                      <div className="com-units">{client.monthlyTotals.VWPACKTotal} uds</div>
                    </div>
                    <div className="com-col col-product">
                      <div className="com-amount">{layComission.toFixed(2)} €</div>
                      <div className="com-units">{client.monthlyTotals.VWLAYTotal} uds</div>
                    </div>
                    <div className="com-col col-product">
                      <div className="com-amount">{goComission.toFixed(2)} €</div>
                      <div className="com-units">{client.monthlyTotals.VWGOTotal} uds</div>
                    </div>
                  </div>
                </div>
              );
            })}
          </div>
        )}
      </div>
    );
  }
}

const mapStateToProps = state => ({
  arqueos: state.arqueos.arqueos,
  error: state.arqueos.error,
  loading: state.arqueos.loading,
  customers: state.customers.customers,
  role: state.auth.role,
  form: state.form
})

const mapDispatchToProps = dispatch => ({
  fetchArqueos: bindActionCreators(fetchArqueos, dispatch),
  fetchCustomers: bindActionCreators(fetchCustomers, dispatch),
  push: bindActionCreators(push, dispatch)
})

export default connect(mapStateToProps, mapDispatchToProps)(ComissionsView)

